import React, { useContext, useState } from "react";
import Row from "@amzn/meridian/row";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import { FormattedMessage } from "react-intl";
import {
  ASSIGNABLE,
  DEPARTED,
  NOT_READY,
  PENDING_DEPART,
  PENDING_STAGE,
  isRouteAtRiskForSSD,
  isRouteStaged,
} from "../outboundAmzl/RouteStatusManager";
import Link from "@amzn/meridian/link";
import Icon from "@amzn/meridian/icon";
import { getDocumentURL } from "../handler/ParentDataHandler";
import { OutboundFilterContext } from "../outboundAmzl/context/OutboundFilterContext";
import ScrollableElementWrapper from "../CommonModels/ScrollableElementWrapper";
import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small";
import chevronLeftSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-left-small";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";
import Text from "@amzn/meridian/text";
import Column from "@amzn/meridian/column";
import FullScreen from "react-full-screen";
import {
  ASSIGNED,
  IN_PROGRESS,
  INTERIM_STAGED,
  ONE_HOUR_DELIVERY,
  STAGED,
  STOWED,
} from "./util/Constants";
import {
  getDisplayProgress,
  getRouteColor,
  getStagingLocation,
  renderRouteBox,
} from "./util/Util";
import {
  createDockDoorRouteMap,
  createRouteWaveList,
  createRouteWaveListForSSDMMOT,
  createAnchorPointRouteMap,
  getDockDoor,
} from "./util/CreateRouteWaveList";
import Button from "@amzn/meridian/button";
import { getStationCode } from "../network/NetworkUtil";
import { OutboundConfigContext } from "../outboundAmzl/context/OutboundConfigContext";
import { getBaseUrl } from "../outboundAmzl/util/Util";
import PaginatedRowContainer from "./util/PaginatedRowContainer";

const TabularGridViewSSD = (props) => {
  const { spacingInset_shorthand2 } = useDeviceLayout;
  const { viewModelF } = useContext(OutboundFilterContext);
  const { outboundConfigModel } = useContext(OutboundConfigContext);
  const [screenState, setScreenState] = useState(false);
  const [expandedWaves, setExpandedWaves] = useState(new Set([]));
  const partialIconSrc =
    "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjIgMjIiPjxjaXJjbGUgY3g9IjExIiBjeT0iLTEwNDEuMzYiIHI9IjgiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwLTEgMC0xMDMwLjM2KSIgb3BhY2l0eT0iLjk4IiBmaWxsPSIjZGE0NDUzIi8+PHBhdGggZD0ibS0yNi4zMDkgMTguMDdjLTEuMTggMC0yLjEzNS45NjgtMi4xMzUgMi4xMjl2MTIuODJjMCAxLjE3Ni45NDggMi4xMjkgMi4xMzUgMi4xMjkgMS4xODMgMCAyLjEzNS0uOTY4IDIuMTM1LTIuMTI5di0xMi44MmMwLTEuMTc2LS45NDYtMi4xMjktMi4xMzUtMi4xMjl6bTAgMjEuMzQ4Yy0xLjE4IDAtMi4xMzUuOTU0LTIuMTM1IDIuMTM1IDAgMS4xOC45NTQgMi4xMzUgMi4xMzUgMi4xMzUgMS4xODEgMCAyLjEzNS0uOTU0IDIuMTM1LTIuMTM1IDAtMS4xOC0uOTUyLTIuMTM1LTIuMTM1LTIuMTM1eiIgdHJhbnNmb3JtPSJtYXRyaXgoLjMwMDU2IDAgMCAuMzAwNTYgMTguOTAyIDEuNzI4KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIi8+PC9zdmc+";
  var dispatchWindowChildrenRenderingFunctions = {
    ANCHOR_POINT: {
      mappingFunction: createAnchorPointRouteMap,
      rowRenderingFunction: renderAnchorPointRow,
    },
    DOCK_DOOR: {
      mappingFunction: createDockDoorRouteMap,
      rowRenderingFunction: renderDockDoorRow,
    },
  };
  const isSSDMMOTEnabled = outboundConfigModel.stationConfig.ssdmmotenabled;
  const dispatchWindowChildrenToBeRendered = ["ANCHOR_POINT", "DOCK_DOOR"];

  const toggleScreen = () => {
    setScreenState(!screenState);
  };

  const renderRouteListContent = (wave) => {
    const paginationEnabledDeliveryWindows = [ONE_HOUR_DELIVERY];
    const shouldUsePagination =
      Array.isArray(wave.routeList) &&
      wave.routeList.length > 0 &&
      paginationEnabledDeliveryWindows.includes(
        wave.routeList[0].deliveryWindow,
      );

    const rowContent = (
      <Row
        width="100%"
        spacing="small"
        wrap={"down"}
        spacingInset={"small none small none"}
      >
        {renderVisualGridBoxes(wave.routeList)}
      </Row>
    );

    return shouldUsePagination ? (
      <PaginatedRowContainer
        maxRows={2}
        leftButtonLabel={
          <FormattedMessage id="pagination.earlier" defaultMessage="Earlier" />
        }
        rightButtonLabel={
          <FormattedMessage id="pagination.later" defaultMessage="Later" />
        }
      >
        {rowContent}
      </PaginatedRowContainer>
    ) : (
      rowContent
    );
  };

  const expandWave = (waveName) => {
    const newExpandedWaves = new Set(expandedWaves);
    if (newExpandedWaves.has(waveName)) {
      newExpandedWaves.delete(waveName);
    } else {
      newExpandedWaves.add(waveName);
    }
    setExpandedWaves(newExpandedWaves);
  };

  const isWaveExpanded = (waveName) => {
    return expandedWaves.has(waveName);
  };

  let routeWaveList = isSSDMMOTEnabled
    ? createRouteWaveListForSSDMMOT(props.routeList)
    : createRouteWaveList(props.routeList);
  const getDefaultLegend = (color, labelId, defaultLabel) => {
    return (
      <Row wrap={"none"} spacing={"small"}>
        {renderRouteBox(color)}
        <Text>
          <FormattedMessage id={labelId} defaultMessage={defaultLabel} />
        </Text>
      </Row>
    );
  };

  function naIfDefault(value) {
    return !value || value === "..." ? "NA" : value;
  }

  const onRouteClick = (route) => {
    getDocumentURL().then((result) => {
      const params = [
        "Overview",
        naIfDefault(route.routeId),
        naIfDefault(encodeURIComponent(route.rswsStatus)),
        naIfDefault(encodeURIComponent(route.stagingLocation)),
        naIfDefault(route.hazmatWeight),
        naIfDefault(route.picker),
        naIfDefault(route.routeCode),
        naIfDefault(route.stationCode),
      ];
      const url = new URL(result.replace("outboundAMZL", "pick"));
      const shareableLink = "/routeDetail/" + params.join("/");
      url.searchParams.set("shareableLink", shareableLink);
      window.open(url.href, "_blank");
    });
  };

  const onManifestGenerationButtonClick = (dockDoor) => {
    getDocumentURL().then((result) => {
      let baseURL = getBaseUrl(result);
      const url = new URL(
        baseURL +
          "/rsws/manifest/stationCode/" +
          getStationCode() +
          "?stagingLocation=" +
          dockDoor,
      );
      window.open(url.href, "_blank");
    });
  };

  const isAnyRouteStagedAtDockDoor = (routeList) => {
    const route = routeList.find((route) => {
      return isRouteStaged(route) && getDockDoor(route);
    });
    return !!route;
  };

  const getToolTipBody = (route) => {
    return (
      <Column className="tooltip-text" spacing={"none"}>
        <Row alignmentHorizontal={"center"}>
          <b>{route.routeCode}</b>
          <br />
        </Row>
        <Column spacing={"none"} alignmentHorizontal={"left"}>
          {getDisplayProgress(route)}
          {getStagingLocation(route)}
        </Column>
      </Column>
    );
  };

  const renderVisualGridBoxes = (routeList) => {
    return routeList.map((route) => (
      <a
        key={route.routeId}
        onClick={() => {
          onRouteClick(route);
        }}
        style={{ textDecoration: "none", cursor: "pointer" }}
      >
        <Row className="html-tooltip" spacing={"none"} spacingInset={"none"}>
          {getToolTipBody(route)}
          {renderRouteBox(
            getRouteColor(route.overviewStatus),
            isRouteAtRiskForSSD(route, viewModelF.cptTimeLimit),
            route.isPartial,
          )}
        </Row>
      </a>
    ));
  };

  /** This function is to render children of a row containing routes.
   * For e.g. currently delivery window row contains routes based on delivery window. Let's say we want to split/render
   * those routes also on the basis of staging location, then this function can render the child rows
   * containing staging location and corresponding routes.
   * wave: It represents the routes and key of parent row.
   * children: Array of Children names to be rendered.
   * */
  const renderChildRows = (parent, children) => {
    if (
      !isWaveExpanded(parent.key) ||
      !(Array.isArray(parent.routeList) && parent.routeList.length) ||
      !(Array.isArray(children) && children.length)
    ) {
      return [];
    }
    let currentChild = children[0];
    let childRouteMap = dispatchWindowChildrenRenderingFunctions[
      currentChild
    ].mappingFunction(parent.routeList);
    return Array.from(childRouteMap, ([child, routeList]) => {
      let childRow = dispatchWindowChildrenRenderingFunctions[
        currentChild
      ].rowRenderingFunction(parent.key, child, routeList);
      if (children.length > 1) {
        return childRow.concat(
          renderChildRows(
            { key: parent.key + child, routeList: routeList },
            children.slice(1),
          ),
        );
      } else {
        return childRow;
      }
    });
  };

  function renderAnchorPointRow(parentKey, anchorPoint, routeList) {
    return [
      <TableRow
        key={`${parentKey}${anchorPoint}`}
        backgroundColor="lightyellow"
      >
        <TableCell alignmentHorizontal="right">
          {isAnyRouteStagedAtDockDoor(routeList) ? (
            <Link
              data-expand-link={parentKey + anchorPoint}
              onClick={() => expandWave(parentKey + anchorPoint)}
              type={"secondary"}
              size={"small"}
            >
              {isWaveExpanded(parentKey + anchorPoint) ? (
                <Icon tokens={chevronDownSmallTokens} />
              ) : (
                <Icon tokens={chevronLeftSmallTokens} />
              )}
            </Link>
          ) : null}
          {anchorPoint}
        </TableCell>
        {/* Adding a column so that child of anchor point row i.e. dock door rows
         can start from a bit right side to show the parent child relationship.
         In current scenario, Dock Door level rows will show Dock Door name in this column.
         For rest of the rows, it will be Overall. */}
        <TableCell>
          <FormattedMessage id="outboundSSD.overall" defaultMessage="Overall" />
        </TableCell>
        <TableCell alignmentHorizontal="center">{routeList.length}</TableCell>
        <TableCell>
          <Row
            width="100%"
            spacing="small"
            wrap={"down"}
            spacingInset={"small none small none"}
          >
            {renderVisualGridBoxes(routeList)}
          </Row>
        </TableCell>
        {/*Adding an empty column in anchor point level rows because the children of anchor point
        are dock door level rows which contains an additional column in end. This last column of dock door
        level rows, contains a button to print the manifest.*/}
        <TableCell />
      </TableRow>,
    ];
  }
  function renderDockDoorRow(parentKey, dockDoor, routeList) {
    return (
      <TableRow key={`${parentKey}${dockDoor}`} backgroundColor="white">
        {/* Adding an empty column so that parent of dock door row i.e. anchor point rows
         can start from a bit left side to show the parent child relationship.*/}
        <TableCell />
        <TableCell alignmentHorizontal="center">{dockDoor}</TableCell>
        <TableCell alignmentHorizontal="center">{routeList.length}</TableCell>
        <TableCell>
          <Row
            width="100%"
            spacing="small"
            wrap={"down"}
            spacingInset={"small none small none"}
          >
            {renderVisualGridBoxes(routeList)}
          </Row>
        </TableCell>
        <TableCell>
          <Button
            id={`${dockDoor}_manifestButton`}
            type="tertiary"
            size="small"
            onClick={() => {
              onManifestGenerationButtonClick(dockDoor);
            }}
          >
            <FormattedMessage
              id="outboundSSD.printManifest"
              defaultMessage="Print Manifest"
            />
          </Button>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <div>
      <Row
        widths={["grid-12"]}
        alignmentVertical="top"
        spacingInset={spacingInset_shorthand2}
      >
        <div>
          <FullScreen
            enabled={screenState}
            onChange={(enabled) => setScreenState(enabled)}
          >
            <ScrollableElementWrapper>
              <Table
                showDividers={true}
                showStripes={true}
                headerRows={1}
                spacing="small"
                headerColumns={1}
                stickyHeaderColumn={true}
                fixHeaderRows={true}
              >
                <TableRow>
                  <TableCell alignmentHorizontal="center">
                    <FormattedMessage
                      id="outboundSSD.window"
                      defaultMessage="Window"
                    />
                  </TableCell>
                  {!isSSDMMOTEnabled ? (
                    <TableCell alignmentHorizontal="center">
                      <FormattedMessage
                        id="outboundSSD.duration"
                        defaultMessage="Length"
                      />
                    </TableCell>
                  ) : (
                    /* Adding a column to display location of route for SSD MMOT which can be dock door, overall .*/
                    <TableCell alignmentHorizontal="center">
                      <FormattedMessage
                        id="outboundSSD.location"
                        defaultMessage="Location"
                      />
                    </TableCell>
                  )}
                  <TableCell alignmentHorizontal="center">
                    <FormattedMessage
                      id="outboundSSD.routes"
                      defaultMessage="Routes"
                    />
                  </TableCell>
                  <Row
                    widths={["grid-10", "grid-2"]}
                    spacing="xlarge"
                    alignmentHorizontal={"left"}
                  >
                    <Row spacing={"none small"}>
                      {getDefaultLegend(
                        getRouteColor(NOT_READY),
                        "outboundSSD.inProgress",
                        IN_PROGRESS,
                      )}
                      {getDefaultLegend(
                        getRouteColor(ASSIGNABLE),
                        "outboundSSD.stowed",
                        STOWED,
                      )}
                      {getDefaultLegend(
                        getRouteColor(PENDING_STAGE),
                        "outboundSSD.assigned",
                        ASSIGNED,
                      )}
                      {isSSDMMOTEnabled &&
                        getDefaultLegend(
                          getRouteColor(INTERIM_STAGED),
                          "outboundSSD.interimStaged",
                          INTERIM_STAGED,
                        )}
                      {getDefaultLegend(
                        getRouteColor(PENDING_DEPART),
                        "outboundSSD.staged",
                        STAGED,
                      )}
                      {getDefaultLegend(
                        getRouteColor(DEPARTED),
                        "outboundSSD.departed",
                        DEPARTED,
                      )}
                      {
                        <Row wrap={"none"} spacing={"small"}>
                          {renderRouteBox("primary", true)}
                          <Text>
                            <FormattedMessage
                              id="outboundSSD.routeAtRisk"
                              defaultMessage={"Risk Late"}
                            />
                          </Text>
                        </Row>
                      }
                      <Row wrap={"none"} spacing={"small"}>
                        <img
                          className="partial-icon"
                          alt={"partial"}
                          src={partialIconSrc}
                          width="16px"
                          height="16px"
                        />
                        <Text>
                          <FormattedMessage
                            id="outboundSSD.partial"
                            defaultMessage={"Partial"}
                          />
                        </Text>
                      </Row>
                    </Row>
                    <Row alignmentHorizontal={"right"} spacing={"none"}>
                      <Link onClick={toggleScreen} type="secondary">
                        <FormattedMessage
                          id="outboundSSD.toggleFullscreen"
                          defaultMessage="Toggle fullscreen"
                        />
                      </Link>
                    </Row>
                  </Row>
                  {/*Adding an empty column in header row because dock door level rows contains
                  an additional column in end. This last column of dock door
                  level rows, contains a button to print the manifest.*/}
                  <TableCell />
                </TableRow>
                {routeWaveList.map((wave, index) => {
                  /*Fixing white color for even rows and grey color for odd rows.
                  This is required to make sure that child rows rendering do not change the color
                  of already rendered parent rows.*/
                  var backgroundColor;
                  if (index % 2 === 1) {
                    backgroundColor = "WhiteSmoke";
                  } else {
                    backgroundColor = "white";
                  }
                  var tableRow = [
                    <TableRow key={wave.key} backgroundColor={backgroundColor}>
                      <TableCell alignmentHorizontal="center">
                        {isSSDMMOTEnabled ? (
                          <Link
                            data-expand-link={wave.key}
                            onClick={() => expandWave(wave.key)}
                            type={"secondary"}
                            size={"small"}
                          >
                            {isWaveExpanded(wave.key) ? (
                              <Icon tokens={chevronDownSmallTokens} />
                            ) : (
                              <Icon tokens={chevronLeftSmallTokens} />
                            )}
                          </Link>
                        ) : null}
                        {wave.name}
                      </TableCell>
                      {!isSSDMMOTEnabled ? (
                        <TableCell alignmentHorizontal="center">
                          {wave.length}
                        </TableCell>
                      ) : (
                        /* Adding an empty column as for SSD MMOT use cases, length of route is not required.
                        In current scenario, Dock Door level rows will show Dock Door name in this column.
                        For rest of the rows, it will be empty.*/
                        <TableCell />
                      )}
                      <TableCell alignmentHorizontal="center">
                        {wave.routeList.length}
                      </TableCell>
                      <TableCell>{renderRouteListContent(wave)}</TableCell>
                      {/*Adding an empty column in window rows because dock door level rows contains
                       an additional column in end. This last column of dock door
                       level rows, contains a button to print the manifest.*/}
                      <TableCell />
                    </TableRow>,
                  ];
                  if (isSSDMMOTEnabled) {
                    return tableRow.concat(
                      renderChildRows(wave, dispatchWindowChildrenToBeRendered),
                    );
                  } else {
                    return tableRow;
                  }
                })}
              </Table>
            </ScrollableElementWrapper>
          </FullScreen>
        </div>
      </Row>
    </div>
  );
};

export default TabularGridViewSSD;



// WEBPACK FOOTER //
// ./src/components/outboundSSD/TabularGridViewSSD.js